import { apiSlice, publicApiSlice } from "@app/apiSlice";
import { createDropdownOptionsApi } from "./createDropdownOptionsApi";
// Create both private and public API slices
export const dropdownOptionsApiSlice = createDropdownOptionsApi(apiSlice);
export const publicDropdownOptionsApiSlice = createDropdownOptionsApi(publicApiSlice);

// Export hooks for private API
export const {
	useGetLandUseTypesQuery,
	useGetTypesOfFisheryQuery,
	useGetFishCategoriesQuery,
	useGetLargeFishGearCategoriesQuery,
	useGetSmallFishGearCategoryQuery,
	useGetCropTypesQuery,
	useGetOrganicInputTypesQuery,
	useGetResidueTypesQuery,
	useGetTillageTypesQuery,
	useGetGrasslandTypesQuery,
	useGetGWPSourcesQuery,
	useGetCountriesQuery,
	useCreateExecutingAgencyMutation,
	useCreateFundingAgencyMutation,
	useGetExecutingAgenciesQuery,
	useGetFundingAgenciesQuery,
	useGetForestTypesQuery,
	useGetForestConditionTypesQuery,
	useGetTrophicTypesQuery,
	useGetWaterbodyTypesQuery,
	useGetMacroFuelTypesQuery,
	useGetFuelTypesQuery,
	useGetIrrigationSystemTypesQuery,
	useGetSettlementTypesQuery,
	useGetChangeRatesQuery,
	useGetClimateTypesQuery,
	useGetMoistureTypesQuery,
	useGetRefrigerantTypesQuery,
	useGetPackagingMaterialTypesQuery,
	useGetInputTypesQuery,
	endpoints,
} = dropdownOptionsApiSlice;

// Export hooks for public API - only read operations
export const {
	useGetLandUseTypesQuery: usePublicGetLandUseTypesQuery,
	useGetTypesOfFisheryQuery: usePublicGetTypesOfFisheryQuery,
	useGetFishCategoriesQuery: usePublicGetFishCategoriesQuery,
	useGetLargeFishGearCategoriesQuery: usePublicGetLargeFishGearCategoriesQuery,
	useGetSmallFishGearCategoryQuery: usePublicGetSmallFishGearCategoryQuery,
	useGetCropTypesQuery: usePublicGetCropTypesQuery,
	useGetOrganicInputTypesQuery: usePublicGetOrganicInputTypesQuery,
	useGetResidueTypesQuery: usePublicGetResidueTypesQuery,
	useGetTillageTypesQuery: usePublicGetTillageTypesQuery,
	useGetGrasslandTypesQuery: usePublicGetGrasslandTypesQuery,
	useGetGWPSourcesQuery: usePublicGetGWPSourcesQuery,
	useGetCountriesQuery: usePublicGetCountriesQuery,
	useGetExecutingAgenciesQuery: usePublicGetExecutingAgenciesQuery,
	useGetFundingAgenciesQuery: usePublicGetFundingAgenciesQuery,
	useGetForestTypesQuery: usePublicGetForestTypesQuery,
	useGetForestConditionTypesQuery: usePublicGetForestConditionTypesQuery,
	useGetTrophicTypesQuery: usePublicGetTrophicTypesQuery,
	useGetWaterbodyTypesQuery: usePublicGetWaterbodyTypesQuery,
	useGetMacroFuelTypesQuery: usePublicGetMacroFuelTypesQuery,
	useGetFuelTypesQuery: usePublicGetFuelTypesQuery,
	useGetIrrigationSystemTypesQuery: usePublicGetIrrigationSystemTypesQuery,
	useGetSettlementTypesQuery: usePublicGetSettlementTypesQuery,
	useGetChangeRatesQuery: usePublicGetChangeRatesQuery,
	useGetClimateTypesQuery: usePublicGetClimateTypesQuery,
	useGetMoistureTypesQuery: usePublicGetMoistureTypesQuery,
	useGetRefrigerantTypesQuery: usePublicGetRefrigerantTypesQuery,
	useGetPackagingMaterialTypesQuery: usePublicGetPackagingMaterialTypesQuery,
	useGetInputTypesQuery: usePublicGetInputTypesQuery,
} = publicDropdownOptionsApiSlice;